import { clientFetch } from '~/api/clientFetch';
import { User } from '../../types/model/user';

export type UsersResponseType = {
  users: User[];
};

type userSearchParams = {
  email?: string;
  full_name?: string;
  page?: string;
  f?: string;
};

const endpoint = '/users';

export async function fetchUsers(
  signOut: () => void,
  searchParams?: userSearchParams
): Promise<{ data: UsersResponseType; headers: Record<string, string> }> {
  const queryString = new URLSearchParams(searchParams).toString();
  const response = await clientFetch(
    endpoint,
    {
      method: 'GET',
      queryString,
    },
    signOut
  );
  const data = await response.json();

  return {
    data,
    headers: Object.fromEntries(response.headers.entries()),
  };
}

export async function fetchUsersCSV(
  signOut: () => void,
  searchParams?: userSearchParams
): Promise<{ data: Blob }> {
  const queryString = new URLSearchParams(searchParams).toString();
  const response = await clientFetch(
    `${endpoint}.csv`,
    {
      method: 'GET',
      queryString,
    },
    signOut
  );
  const data = await response.blob();

  return { data };
}
